import api from '@/api/meetingRoom'

const state = {

}

const actions = {
  getInterviewMeetingRoomList (context, params) {
    return api.getInterviewMeetingRoomList(params)
  },
  getInterviewMeetingRoomById (context, { id, params }) {
    return api.getInterviewMeetingRoomById(id, params)
  },
  createInterviewMeetingRoom (context, params) {
    return api.createInterviewMeetingRoom(params)
  },
  updateInterviewMeetingRoom (context, { id, data }) {
    return api.updateInterviewMeetingRoom(id, data)
  },
  deleteInterviewMeetingRoom (context, { id, params }) {
    return api.deleteInterviewMeetingRoom(id, params)
  },
  getInterviewMeetingRoomSchedule (context, data) {
    return api.getInterviewMeetingRoomSchedule(data)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
